import type { HmsApprovalMode } from '../../api/hms';

/** Without a main safety representative, HR approves on its own */
export const initialApprovalMode = (hasMainSafetyRep: boolean): HmsApprovalMode =>
  hasMainSafetyRep ? 'SAFETY_REP' : 'HR_WITHOUT_SAFETY_REP';

/**
 * HR going past the main safety representative must justify it, and so must HR who is the only main safety
 * representative, as no one approves their own work in another role
 */
export const approvalCommentMissing = (mode: HmsApprovalMode, comment: string, commentRequired: boolean) =>
  commentRequired && mode === 'HR_WITHOUT_SAFETY_REP' && !comment.trim();

export const approvalCommentRequired = (setup: { hasMainSafetyRep: boolean; mainSafetyRepIsYou?: boolean }) =>
  setup.hasMainSafetyRep || Boolean(setup.mainSafetyRepIsYou);
